module.exports = __webpack_public_path__ + "img/horseback-riding-3.551eebb8.jpg";